<template>
  <div class="login-main">
    <div class="login-wrap">
      <h2>로그인</h2>
      <p>예약을 하기 위해서는 로그인이 필요합니다.</p>
      <div class="input-area">
        <ul>
          <li>
            <AInput
              id="idHpNo"
              class="login-inp"
              v-model="idHpNo"
              placeholder="아이디를 입력하세요"
            />
            <AButton @click="onClickRemove" class="btn-x"
              ><img src="@assets/img/ic_x.svg" alt="remove"
            /></AButton>
          </li>
          <li>
            <AInput
              type="password"
              id="password"
              class="login-inp"
              placeholder="비밀번호를 입력하세요"
              autocomplete="new-password"
              v-model="password"
              @keyup.enter="handleSignIn"
            />
            <AButton @click="onClickRemove" class="btn-x"
              ><img src="@assets/img/ic_x.svg" alt="remove"
            /></AButton>
          </li>
        </ul>
      </div>
      <div class="save-idpw">
        <ACheckbox id="saveIdCheck" class="" v-model="saveIdCheck"
          >아이디 저장하기
        </ACheckbox>
      </div>
      <div class="btn-basic mt50">
        <button type="button" class="on" @click="handleSignIn">로그인</button>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { AButton, ACheckbox, AInput } from '@atoms';
import { useSignIn } from '@composables';
import { ROUTE_NAME } from '@constants';
import { useRouter } from 'vue-router';
import { useUserStore } from '@stores';
const userStore = useUserStore();

const emits = defineEmits(['signIn']);
const { push } = useRouter();
const { idHpNo, password, saveIdCheck, handleSignIn: signIn } = useSignIn();

const handleSignIn = async () => {
  try {
    if (await signIn()) {
      userStore.setUserIdForSignupComplete(idHpNo.value);
      const redirect = localStorage.getItem('redirect');
      if (redirect) {
        await push(redirect as string);
      }
      await push({ name: ROUTE_NAME.Main });
      emits('signIn');
    }
  } catch (error) {
    if (error === 'NO_PASSWORD') {
      // 비밀번호 찾기 팝업 or 페이지 이동
      // modalRef.value.open();
    }
  }
};

const onClickRemove = async () => {
  idHpNo.value = '';
  password.value = '';
};
</script>

<style scoped lang="scss">
.login-main {
  background-color: #f8f9fc;
  width: 100%;
  min-height: calc(100vh - 120px);
  padding: 206px 0 170px;
}

.login-wrap {
  width: 460px;
  margin: auto;
  padding: 60px;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
}

.login-wrap h2 {
  font-size: 36px;
  font-weight: bold;
  padding-bottom: 30px;
  text-align: center;
}

.login-wrap p {
  padding-bottom: 53px;
  text-align: center;
}

.input-area ul {
  display: flex;
  flex-direction: column;
  gap: 20px 0;
}

.input-area ul li {
  position: relative;
  width: 100%;
}
.input-area ul li input[type='text'],
.input-area ul li input[type='password'] {
  padding: 14px 60px 14px 16px;
}
.input-area ul li button {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 5;
}

.save-idpw {
  margin: 15px 0;
}

// Mobile
@media (max-width: 884px) {
  .login-main {
    padding: 112px 0 170px;
  }
  .login-wrap {
    width: 90%;
    max-width: 343px;
    padding: 48px 32px;
  }

  .login-wrap h2 {
    font-size: var(--f26);
    padding-bottom: 15px;
  }

  .login-wrap p {
    padding-bottom: 32px;
    font-size: var(--f14);
  }
}
</style>
